<template>
  <v-flex class="pa-1" data-qa="fileupload-flex-u8o82o">
    <v-file-input
      v-model="files"
      @change="setData($event)"
      :label="$t('docUpload.selectFile')"
      accept=".pdf, .png, .jpeg, .jpg, .doc, .docx"
      show-size
      :error="error"
      :color="primaryColor"
      :key="fileInputKey"
     data-qa="fileupload-file-input-i37vy"></v-file-input>
    <Modal :config="modalConfig" @cancel="modalConfig.enabled = false">
      <div slot="modalContent" id="viewPdfFile" class="pdf-viewer" data-qa="fileupload-div-0cazd"></div>
    </Modal>
  </v-flex>
</template>

<script>
import '@/styles/components/fileUpload.scss'
import PDFObject from '@/core/_helpers/pdfViewer'
import store from '@/core/store'
import event from '@/util/event'
import { PDFDict, PDFDocument } from 'pdf-lib'

export default {
  name: 'File-Upload',
  data () {
    return {
      files: [],
      acceptFileTypes: [
        '.pdf',
        '.png',
        '.PNG',
        '.JPEG',
        '.JPG',
        '.jpeg',
        '.jpg',
        '.doc',
        '.docx'
      ],
      imageFileTypes: ['.png', '.jpeg', '.jpg', '.PNG', '.JPEG', '.JPG'],
      urlPdf: undefined,
      enablePdfViewer: false,
      maxSize: this.$appSettings.defaultConfigurations.maxUploadFileSize,
      error: false,
      color: undefined,
      fileTypeExists: false,
      showPreview: true,
      modalConfig: {
        enabled: false,
        title: this.$t('personalSettings.fileUpload.preview'),
        width: '800px',
        persistent: true,
        cancelButton: this.$t('personalSettings.buttons.close'),
        outlinedCancelBtn: true
      },
      fileInputKey: 0
    }
  },
  components: {
    Modal: () => import('@/components/common/Modal.vue')
  },
  created () {
    event.$on('removeFile', arg => {
      this.files = []
      this.error = false
      this.color = '#757575'
      this.fileTypeExists = false
      event.$emit('addressDocSelected', false)
      store.dispatch('profileStore/setProfileData', {
        fileType: undefined,
        file: undefined
      })
    })
  },
  methods: {
    readFileAsync (file) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onload = (e) => {
          resolve(e.target.result)
        }
        reader.readAsArrayBuffer(file)
      })
    },
    async setData (file) {
      this.fileInputKey++
      let newFile = file
      this.error = false
      this.color = '#757575'
      if (file && file.name) {
        this.$emit('deleteAddressDocSelected', undefined)
        event.$emit('addressDocSelected', file)

        const fileExtension = file.name.substr((file.name.lastIndexOf('.')))

        /* Do a strict file ext check for doc/img to restrict malicious file upload */
        if (this.acceptFileTypes.includes(fileExtension)) {
          event.$emit('addressDocSelected', file)
          this.fileTypeExists = true
        }

        if (this.imageFileTypes.includes(fileExtension)) {
          this.showPreview = false
        }

        if (this.fileTypeExists) {
          if (fileExtension === '.pdf') {
            try {
              const content = await this.readFileAsync(file)
              const pdfDoc = await PDFDocument.load(content)
              const pages = pdfDoc.getPages()
              const js = ['/js', '/javascript']
              pages.forEach(page => {
                page.doc.context.enumerateIndirectObjects().forEach(([ref, obj]) => {
                  if (obj.dict instanceof Map || obj.dict instanceof PDFDict) {
                    const itObj = obj.dict instanceof Map ? obj.dict : obj.dict.dict
                    for (const [key, value] of itObj) {
                      if (js.includes(key.toString().toLowerCase()) || js.includes(value.toString().toLowerCase())) {
                        this.fileTypeExists = false
                        this.invalidateInputField(this.fileTypeExists)
                        return
                      }
                    }
                  }
                })
              })

              newFile = await pdfDoc.save()
              newFile = new Blob([newFile], { type: 'application/pdf' })
              newFile = new File([newFile], file.name, { type: 'application/pdf' })
            } catch (e) {
              this.fileTypeExists = false
              this.invalidateInputField(this.fileTypeExists)
              return
            }
          }

          if (Math.round(file.size / 1000) > this.maxSize) {
            this.files = []
            this.error = true
            this.color = this.errorColor
            this.$store.dispatch('appStore/setAppData', {
              message: {
                content: this.$t('personalSettings.fileUpload.warning'),
                type: 'error',
                component: 'dob-snackbar',
                timeOut: 2000
              }
            })
          } else {
            this.color = '#757575'
            this.urlPdf = undefined
            this.enablePdfViewer = true
            this.urlPdf = URL.createObjectURL(file)
            this.$emit('docSeletedCheck', {
              doc: this.urlPdf,
              docType: newFile.name,
              file: newFile
            })
            store.dispatch('profileStore/setProfileData', {
              file: newFile,
              fileType: newFile.type,
              fileName: newFile.name
            })
          }
        } else {
          this.invalidateInputField(this.fileTypeExists)
        }
      } else {
        this.invalidateInputField()
      }
      this.fileTypeExists = false
    },
    displayPdf () {
      this.modalConfig.enabled = true
      setTimeout(() => {
        PDFObject.embed(this.urlPdf, '#viewPdfFile', { forcePDFJS: true })
      }, 10)
    },
    invalidateInputField (fileTypeExists = true) {
      if (!fileTypeExists) {
        this.$store.dispatch('appStore/setAppData', {
          message: {
            content: this.$t('personalSettings.fileUpload.invalidFile'),
            type: 'error',
            component: 'dob-snackbar',
            timeOut: 2000
          }
        })
      }
      this.files = []
      this.error = true
      this.color = this.errorColor
      this.fileTypeExists = false
      event.$emit('addressDocSelected', false)
      store.dispatch('profileStore/setProfileData', {
        fileType: undefined,
        file: undefined
      })
      this.fileInputKey = 0
    }
  },
  watch: {
    color () {
      event.$emit('isFileUploadError', this.color)
    },
    error () {
      if (this.error) {
        this.$emit('deleteAddressDocSelected', undefined)
      }
    }
  }
}
</script>
